import {
  selectHotspotSelected,
  selectListScene,
  selectSceneSelected,
} from '@containers/Home/selectors';
import { actions } from '@containers/Home/slice';
import { useGoogleAnalytics } from '@utils/hooks/useGoogleAnalytics';
import dynamic from 'next/dynamic';
import { memo, useCallback, useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useGetDetailPost } from '../hook/useGetDetailPost';

const DialogHotspotArticle = dynamic(
  () => import('@components/DialogHotspotArticle'),
);
const DialogHotspotProduct = dynamic(
  () => import('@components/DialogHotspotProduct'),
);
const Fancybox = dynamic(() => import('./FancyboxForHotspot'));

// interface Props {}

const ActionHotspot = () => {
  const dispatch = useDispatch();
  const listScene = useSelector(selectListScene);
  const hotspotSelected = useSelector(selectHotspotSelected);
  const currentScene = useSelector(selectSceneSelected);

  const [idArticle, setIdArticle] = useState<string | undefined>(undefined);
  const [visibleDialogArticle, setVisibleDialogArticle] = useState(false);
  const [visibleDialogProduct, setVisibleDialogProduct] = useState(false);

  const { onPushEventClickedHotspot } = useGoogleAnalytics();

  const { detailPost: infoArticle } = useGetDetailPost({ idPost: idArticle });

  const infoLink = useMemo(
    () => hotspotSelected?.config?.link || undefined,
    [hotspotSelected],
  );

  const infoPoint = useMemo(
    () =>
      (hotspotSelected?.type === 'point'
        ? hotspotSelected?.config?.point
        : hotspotSelected?.config?.chevron) || undefined,
    [hotspotSelected],
  );

  const onReset = useCallback(() => {
    dispatch(actions.setHotspotSelected(null));
    setVisibleDialogProduct(false);
    setVisibleDialogArticle(false);
    setIdArticle(undefined);
  }, [dispatch]);

  useEffect(() => {
    // NOTE: update event google analytics
    if (hotspotSelected) onPushEventClickedHotspot();

    if (hotspotSelected && hotspotSelected?.type === 'article') {
      setVisibleDialogArticle(true);
      if (hotspotSelected?.config?.article?.post_id)
        setIdArticle(hotspotSelected?.config?.article?.post_id);
    }
    if (hotspotSelected && hotspotSelected?.type === 'product')
      setVisibleDialogProduct(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hotspotSelected]);

  useEffect(() => {
    if (infoLink?.url) {
      if (infoLink?.action !== 'iframe') {
        window.open(
          infoLink?.url,
          '_blank',
          infoLink?.action === 'new-window'
            ? 'location=yes,height=570,width=520,scrollbars=yes,status=yes'
            : null,
        );
        onReset();
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [infoLink]);

  useEffect(() => {
    if (infoPoint?.target_scene_id) {
      const {
        hlookat_default,
        vlookat_default,
        zoom_default,
        isTransition,
        typeTransition = 'NOBLEND',
      } = infoPoint;
      const scenes = listScene.filter(
        item => item.id === infoPoint?.target_scene_id,
      );
      let sceneSelected = scenes[0];
      sceneSelected = {
        ...sceneSelected,
        ...{
          config: {
            ...sceneSelected?.config,
            default_view: {
              ...sceneSelected?.config?.default_view,
              ...{
                x: hlookat_default || 0,
                y: vlookat_default || 0,
                zoom_lv: zoom_default || 90,
              },
            },
            isTransition,
            typeTransition: isTransition ? typeTransition : 'NOBLEND',
          },
        },
      };
      if (sceneSelected?.id) {
        dispatch(actions.setSceneSelected(sceneSelected));
        dispatch(actions.setprevSceneSelected(currentScene));
        onReset();
      }
    }
  }, [currentScene, dispatch, infoPoint, listScene, onReset]);

  return (
    <>
      <DialogHotspotArticle
        visible={visibleDialogArticle}
        onCancel={onReset}
        post={infoArticle}
        width={hotspotSelected?.config?.article?.popup_width}
      />
      {hotspotSelected?.itemPrd && (
        <DialogHotspotProduct
          onCancel={onReset}
          visible={visibleDialogProduct}
          product={hotspotSelected?.itemPrd}
        />
      )}

      {hotspotSelected && (
        <Fancybox hotspotSelected={hotspotSelected} onClose={onReset} />
      )}
    </>
  );
};

export default memo(ActionHotspot);
